<template>
  <div class="box">
    <transition appear @before-enter="beforeEnter" @enter="enter">
      <h2 data-index="1">Work Experience</h2></transition
    >
    <transition-group
      tag="div"
      appear
      @before-enter="beforeEnterBox"
      @enter="enterBox"
    >
      <Experience
        v-for="(experience, index) in experiences"
        :key="experience.date"
        :data-index="index"
        :experience="experience"
      />
    </transition-group>
  </div>
</template>
<script>
import Experience from "./Experience.vue";
export default {
  props: {
    experiences: Array,
    beforeEnterBox: Function,
    enterBox: Function,
    beforeEnter: Function,
    enter: Function,
  },
  components: { Experience },
};
</script>
<style scoped>
#resume .section > div > h2 {
  background: var(--secondary);
}
#resume .section > div:hover > h2 {
  padding-left: 3rem;
  padding-right: 3rem;
  background: var(--primary);
  color: var(--dark);
}
#resume .box div div {
  background: var(--grey);
  color: var(--light);
}
@media screen and (max-width: 520px) {
  #resume .section > div:hover > h2 {
    padding: 7px 25px;
  }
}
</style>
